import React, { Component } from 'react'

import './BigImage.css'

class BigImage extends Component {

    constructor(props){
        super(props)

        this.state = {
            isLoaded: false
        }

        this.onLoad = this.onLoad.bind(this)
    }

    onLoad(){
        this.setState({
            isLoaded: true
        })
    }


    render() {

        const { data } = this.props
        const { title, file } = data.fields

        const { isLoaded } = this.state

        const imageStyle = {
            opacity: isLoaded ? 1 : 0
        }
        
        const bgStyle = {
            backgroundImage: `url(${file.url})`,
            opacity: isLoaded ? 1 : 0
        }

        return (

            <div className="big-image" style={bgStyle}>
                <img src={file.url} alt={title} style={imageStyle} onLoad={this.onLoad} />
            </div>


        );
    }
}


export default BigImage;